import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Grid, TableCell as TableCell, tableCellClasses, TableRow } from '@kc-console/common-ui';
import { np } from '@kc-console/core';

import { EmptyState } from '../EmptyState';

import type { CSSProperties } from 'react';
import type { EmptyStateProps } from '../EmptyState';

export interface DataTableEmptyStateProps
  extends Pick<EmptyStateProps, 'type' | 'illustration' | 'message' | 'guideText' | 'action'> {
  colSpan?: number;
  /** Container 영역의 CSS를 재정의합니다. */
  containerStyle?: CSSProperties;
  onRefetch?: () => void;
  tableContainerWidth?: number | null;
}

export default function DataTableEmptyState(props: DataTableEmptyStateProps) {
  const {
    type: emptyStateType,
    colSpan = 999,
    onRefetch,
    containerStyle = {},
    tableContainerWidth = null,
    ...others
  } = props;

  return (
    <TableRow>
      <StyledTableCell colSpan={colSpan} align="center">
        <Container container alignItems="center" style={containerStyle}>
          <StyledEmptyState
            $tableContainerWidth={tableContainerWidth}
            type={emptyStateType}
            onRefetch={onRefetch}
            {...others}
          />
        </Container>
      </StyledTableCell>
    </TableRow>
  );
}

const StyledTableCell = styled(TableCell)`
  && {
    padding-left: 0;
    padding-right: 0;
  }

  .${tableCellClasses.content} {
    width: 100%;
  }
`;

const Container = styled(Grid)`
  position: relative;
  min-height: 300px;
`;

const StyledEmptyState = styled(EmptyState, {
  shouldForwardProp: np('$tableContainerWidth'),
})<{ $tableContainerWidth: number | null }>(
  ({ $tableContainerWidth }) => css`
    position: sticky;
    left: 0;
    width: ${$tableContainerWidth === null ? '100%' : `${$tableContainerWidth}px`};
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow-wrap: anywhere;
    text-align: center;
  `,
);
